import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const DesignationList = Loadable(lazy(() => import("./DesignationList")));
const DesignationForm = Loadable(lazy(() => import("./DesignationForm")));

const designationRoutes = [
  {
    path: "/Designation/DesignationList",
    element: <DesignationList />,
    permission: PERMISSIONS.Designations.Menu,
  },
  {
    path: "/Designation/DesignationForm",
    element: <DesignationForm />,
  },
  {
    path: "/Designation/DesignationForm/:designationId",
    element: <DesignationForm />,
  },
];

export default designationRoutes;
